// extracted by mini-css-extract-plugin
export default {"buttons":"AnalyseType_buttons__ltha5","title":"AnalyseType_title__XNMbG"};